export const DOCUMENT_REQUIREMENTS = {
    100: ['CRT', 'Sanitary Permit', 'CNPJ', 'AFE', 'AE', 'Book Evidence'], // Distributor
    101: ['CRT', 'Sanitary Permit', 'CNPJ', 'CNES', 'Book Evidence'], // Dispenser
    102: ['CRT', 'Sanitary Permit', 'CNPJ', 'CNES', 'Book Evidence'], // Intermediary
    103: ['CNPJ', 'CNES'], // Prescriber
    104: ['CNPJ'], // Buyer
};

/**
 * Documents that require expiration dates (have validity periods).
 * These documents must have an expiration_date set when uploaded.
 */
export const DOCUMENTS_WITH_EXPIRATION = ['CRT', 'Sanitary Permit'];

/**
 * Check if a document requires an expiration date.
 * @param {string} docName - The document name
 * @returns {boolean} True if the document requires an expiration date
 */
export const documentRequiresExpiration = (docName) => {
    return DOCUMENTS_WITH_EXPIRATION.includes(docName);
};